module.exports = __webpack_public_path__ + "static/microsoft-certified-azure-developer-associate.1-8140273ef8e8f4e0eb4ce93bde2293ab.png";